module.exports = __webpack_public_path__ + "static/media/JAM.d8651c25.png";